const linkRoot = {
  defaultProps: {
    underline: "none",
    color: "inherit",
  },
};

export default linkRoot;
